<template>
  <j-modal 
    :title="title" 
    :width="width" 
    :visible="visible" 
    :confirmLoading="confirmLoading" 
    :keyboard="false" 
    :forceRender="true" 
    switchFullscreen 
    @cancel="handleCancel" 
    style="top:20px;height: 95%;"
    >
    <template slot="footer">
      <a-button @click="handleCancel">关闭</a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row class="form-row" :gutter="24">
            <a-col :span="12/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告单号" prop="code">
                <span>{{form.code}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="报告日期" prop="date">
                <span>{{form.date}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="受理人" prop="acceptedBy">
                <span>{{form.acceptedBy}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号" prop="productNumber">
                <span>{{form.productNumber}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称" prop="productName">
                <span>{{form.productName}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号" prop="productModel">
                <span>{{form.productModel}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品注册证号" prop="licenseNumber">
                <span>{{form.licenseNumber}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册人/备案人" prop="regBy">
                <span>{{form.regBy}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产企业许可证" prop="licenseNumber">
                <span>{{form.licenseNumber}}</span>
              </a-form-model-item>
            </a-col>
            
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="批号/序列号" prop="serialNumber">
                <span>{{form.serialNumber}}</span>
              </a-form-model-item>
            </a-col>
            
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产日期" prop="productDate">
                <span>{{form.productDate}}</span>
              </a-form-model-item>
            </a-col>
            
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量" prop="number">
                <span>{{form.number}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用单位" prop="unit">
                <span>{{form.unit}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="不良事件事故情况" prop="info">
                <span>{{form.info}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="使用单位意见" prop="comOpinion">
                <span>{{form.comOpinion}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="质量负责人意见" prop="personOpinion">
                <span>{{form.personOpinion}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理情况" prop="handle">
                <span>{{form.handle}}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8/1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                <span>{{form.remark}}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
        
      </a-form>
    </a-spin>
    <vendor-modal ref="vendorModalForm" @ok="vendorModalFormOk"></vendor-modal>
    <depot-modal ref="depotModalForm" @ok="depotModalFormOk"></depot-modal>
    <batch-set-depot ref="batchSetDepotModalForm" @ok="batchSetDepotModalFormOk"></batch-set-depot>
    <import-item-modal ref="importItemModalForm" @ok="importItemModalFormOk"></import-item-modal>
    <wait-bill-list ref="waitBillList" @ok="waitBillListOk"></wait-bill-list>
    <workflow-iframe ref="modalWorkflow"></workflow-iframe>
  </j-modal>
</template>
<script>
import pick from 'lodash.pick'
import VendorModal from '../../system/modules/VendorModal'
import DepotModal from '../../system/modules/DepotModal'
import BatchSetDepot from '../dialog/BatchSetDepot'
import ImportItemModal from '../dialog/ImportItemModal'
import WorkflowIframe from '@/components/tools/WorkflowIframe'
import { FormTypes } from '@/utils/JEditableTableUtil'
import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
import { BillModalMixin } from '../mixins/BillModalMixin'
import { getMpListShort } from '@/utils/util'
import JUpload from '@/components/jeecg/JUpload'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import WaitBillList from '../dialog/WaitBillList'
export default {
  name: 'OtherInModal',
  mixins: [JEditableTableMixin, BillModalMixin],
  components: {
    VendorModal,
    DepotModal,
    BatchSetDepot,
    ImportItemModal,
    WaitBillList,
    WorkflowIframe,
    JUpload,
    JDate,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  data() {
    return {
      title: '详情',
      width: '1600px',
      moreStatus: false,
      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      visible: false,
      operTimeStr: '',
      prefixNo: 'XJJU',
      fileList: [],
      rowCanEdit: true,
      //出入库管理开关，适合独立仓管场景
      inOutManageFlag: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      refKeys: ['materialDataTable'],
      activeKey: 'materialDataTable',
      columns: [
          {dataIndex: 'depotName', title: '仓库名称'},
          {dataIndex: 'barCode', title: '条码'},
          {dataIndex: 'materialId', title: 'ID'},
          {dataIndex: 'mname', title: '名称'},
          {dataIndex: 'mstandard', title: '规格'},
          {dataIndex: 'mmodel', title: '型号'},
          {dataIndex: 'materialUnit', title: '单位'},
          {dataIndex: 'operNumber', title: '数量'},
        ],
      confirmLoading: false,
      url: {
        add: '/quality/spotInspection/add',
        edit: '/quality/spotInspection/edit',
        detailList: '/quality/inspectionAssociation/getDetailList',
      },
    }
  },
  created() {},
  methods: {
    show(result){
      this.visible = true
      this.form = result.info
      this.dataSource = result.datalist
    },
    handleCancel() {
      this.visible = false
    },

  },
}
</script>
<style scoped>
</style>